import type { Status } from "@1js/pl-types";
import { useReducer } from "react";
import type { LinkedPrompt } from "../services/prompt-client.web";

export const initialState: DialogState = {
  activePrompt: undefined,
  surface: "list",
  linkedPrompts: [],
  status: "idle",
  toast: "null",
  open: false,
};

type DialogState = {
  activePrompt: LinkedPrompt | undefined;
  surface: "list" | "confirm";
  linkedPrompts: LinkedPrompt[];
  status: Status;
  toast: "null" | "success" | "error";
  open: boolean;
};

type DialogAction =
  | {
      type: "OPEN_DIALOG";
    }
  | {
      type: "LAUNCH_LIST";
      payload: LinkedPrompt[];
    }
  | {
      type: "DELETE_PROMPT";
      payload: LinkedPrompt;
    }
  | {
      type: "DELETE_PROMPT_INIT";
    }
  | {
      type: "DELETE_PROMPT_SUCCEED";
    }
  | {
      type: "DELETE_PROMPT_FAILED";
    }
  | {
      type: "DELETE_PROMPT_CANCEL";
    }
  | {
      type: "CLOSE_LIST";
    };

const reducer = (state: DialogState, action: DialogAction): DialogState => {
  switch (action.type) {
    case "OPEN_DIALOG":
      return {
        ...state,
        status: "loading",
        open: true,
      };
    case "LAUNCH_LIST":
      return {
        ...state,
        linkedPrompts: action.payload,
        surface: "list",
        toast: "null",
        open: true,
        status: "idle",
      };
    case "DELETE_PROMPT":
      return {
        ...state,
        activePrompt: action.payload,
        surface: "confirm",
        toast: "null",
      };
    case "DELETE_PROMPT_INIT":
      return {
        ...state,
        status: "loading",
        toast: "null",
      };
    case "DELETE_PROMPT_SUCCEED":
      return {
        ...state,
        linkedPrompts: state.linkedPrompts.filter(
          (x) => x.PromptId !== state.activePrompt?.PromptId
        ),
        activePrompt: undefined,
        surface: "list",
        status: "idle",
        toast: "success",
      };
    case "DELETE_PROMPT_FAILED":
      return {
        ...state,
        status: "failed",
        toast: "error",
      };
    case "DELETE_PROMPT_CANCEL":
      return {
        ...state,
        activePrompt: undefined,
        surface: "list",
        toast: "null",
      };
    case "CLOSE_LIST":
      return {
        ...state,
        activePrompt: undefined,
        open: false,
      };
  }
};

function useDialog() {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
}
export default useDialog;
